import DetailsSection from 'flow/components/tickets/ticket-details/DetailsSection';
import { TicketKey } from 'flow/types/EntityKeys';
import useTicketFetchOnTicketViewMount from 'flow/hooks/useTicketFetchOnTicketViewMount';

interface Props {
    ticketKey: TicketKey;
}

const TicketTabContent = ({ ticketKey }: Props) => {
    useTicketFetchOnTicketViewMount(ticketKey);

    return <DetailsSection ticketKey={ticketKey} />;
};

export default TicketTabContent;
